import axios from 'axios';

const list = (data) => axios.get('/safe/fighting/list', data);//消防设备列表
const save = (data) => axios.post('/safe/fighting/save', data);//消防设备保存
const update = (data) => axios.put('/safe/fighting/update', data);//消防设备保存
const del = (data) => axios.delete('/safe/fighting/delete', data);//消防设备
const info = (data) => axios.get('/safe/fighting/info/'+data.params.id, data);//详情
const firecontrol = (data) => axios.get('/safe/fighting/group', data);//消防设备分类

//消防设备表计管理
const relationDelete = (data) => axios.delete('/safe/iot/relation/delete', data);
//消防设备运维记录
const opsDelete = (data) => axios.delete('/safe/ops/delete', data);






export default {
  list,
  save,
  del,
  info,
  update,
  relationDelete,
  opsDelete,
  firecontrol,

}


